/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2024 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  function setEqualHeight() {
    const $cards = $('.testimonial-card');
    // Reset the height to auto to calculate natural height
    $cards.css('height', 'auto');
    // Find the tallest card
    let maxHeight = 0;
    $cards.each(function () {
      const cardHeight = $(this).outerHeight();
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });
    // Set the height of all cards to the tallest height
    $cards.css('height', `${maxHeight}px`);
  }

  const $slider = $('.testimonial-3d__multi-sliders');

  // With centerMode + infinite:false, Slick never applies `.slick-active` to
  // any slide, so its accessibility logic (activateADA) never restores the
  // centered card. That leaves the visible card aria-hidden and its links at
  // tabindex="-1", so keyboard users can't tab to them. Restore the current
  // slide (`.slick-current`) on every state change.
  //
  // Slick fires these events *before* it runs initADA() (which re-applies
  // tabindex="-1"), so we defer the restore to run after Slick's ADA pass.
  function restoreCurrentSlideADA($el) {
    const $current = $el.find('.slick-slide.slick-current');
    $current.attr('aria-hidden', 'false');
    $current.find('a, input, button, select').attr('tabindex', '0');
  }

  $slider.on('init reInit afterChange setPosition', function () {
    const $this = $(this);
    window.setTimeout(() => restoreCurrentSlideADA($this), 0);
  });

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0',
    variableWidth: true,
    infinite: false,
    touchMove: false,
    initialSlide: 0,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          initialSlide: 1,
        }
      }
    ]
  });

  // Set equal heights after initializing Slick slider
  $(document).ready(() => {
    const $images = $('.testimonial-card img');
    let imagesLoaded = 0;

    $images.each(function () {
      if (this.complete) {
        imagesLoaded++;
      } else {
        $(this).on('load', () => {
          imagesLoaded++;
          if (imagesLoaded === $images.length) {
            setEqualHeight();
          }
        });
      }
    });

    if (imagesLoaded === $images.length) {
      setEqualHeight();
    }
  });

  $(window).on('resize', () => {
    $slider.slick('resize');
    setEqualHeight();
  });

  // Recalculate heights when the Slick slider position is reset
  $slider.on('setPosition', setEqualHeight);
}(jQuery));
